var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{attrs:{"id":"providers"}},[_c(_vm.activeComponent,{tag:"component",on:{"onSwitch":_vm.swithComponent}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }